import { InternshipEducationLevelEnum } from '@models/internships/internship-education-level.enum';
import { InternshipsExigencyEnum } from '@models/internships/internship-experience.enum';
import { InternshipOfferStatusEnum, SecureSpaceInternshipStatusEnum } from '@models/internships/internship-status.enum';
import { convertDate } from '@models/utils';
import { City } from '@wizbii/models';

export interface InternshipContract {
  durationInDays: number;
  partTime?: any;
  name?: string;
  hoursPerWeek?: number;
}

export enum ReceptionModeEnum {
  Email = 'email',
  RedirectUrl = 'redirect-url',
}

export interface InternshipCompany {
  id: string;
  name: string;
  domain: any;
  description: string;
  logo: string;
  url: string;
}

export interface InternshipRequirements {
  qualities: string[];
  languages: string[];
  tools: string[];
  skills: string[];
  driverLicenses: string[];
  education: {
    exigency?: InternshipsExigencyEnum;
    level: InternshipEducationLevelEnum;
  };
  experience: {
    exigency?: InternshipsExigencyEnum;
    years: number;
  };
}

export interface Internship {
  objectID: string;
  title: string;
  requirements: InternshipRequirements;
  startDate: Date | string;
  contract: InternshipContract;
  rqth: any;
  domain: any;
  location: City;
  creationDate: number;
  companyName: string;
  publicationDate: number;
  provider: string;
}
export interface InternshipContact {
  name: string;
  phone: string;
  mail: string;
}
export interface SecureSpaceInternship {
  id: string;
  title: string;
  description: string;
  requirements: InternshipRequirements;
  startDate: Date | string;
  contract: InternshipContract;
  contact: InternshipContact;
  status: SecureSpaceInternshipStatusEnum;
  rqth: boolean;
  domain: string;
  location: City;
  creationDate: Date;
  companyName: string;
  company: InternshipCompany;
  provider: string;
  salary?: string;
  sourceType: string;
  language: string;
  jobImporterId: string;
  publicationDate: Date | string;
  expirationDate: Date | string;
  url?: string;
  emailReceptionCandidates: string;
}

export interface CreateSecureSpaceInternship {
  title: string;
  location: City;
  company?: InternshipCompany;
  requirements: unknown;
  description: string;
  contract: InternshipContract;
  rqth: true;
  domain: string;
  startDate: Date | string;
  salary?: string;
  url: string;
  provider: string;
  sourceType: string;
  status: SecureSpaceInternshipStatusEnum;
  emailReceptionCandidates: string;
}

export interface UpdateSecureSpaceInternship extends CreateSecureSpaceInternship {
  id: string;
}

export interface InternshipOffer {
  id: string;
  title: string;
  location: City;
  description: string;
  company: InternshipCompany;
  contract: InternshipContract;
  rqth: any;
  domain: string;
  startDate: Date | string;
  salary: string;
  contact: any;
  url: string;
  deletionDate: Date | string;
  expirationDate: Date | string;
  requirements: InternshipRequirements;
  creationDate: Date | string;
  publicationDate: Date | string;
  provider: string;
  status: InternshipOfferStatusEnum;
}

export type OfferDetail = {
  title: string;
  content: string;
} | null;

export interface ApplyInternship {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  cvUrl: string;
  presentation?: string;
  acceptShareData: boolean;
  jobId: string;
}

export function toSecureSpaceInternship(data: any = {}): SecureSpaceInternship {
  return {
    ...data,
    id: data.id ?? data.objectID,
    startDate: convertDate(data.startDate),
    publicationDate: convertDate(data.publicationDate),
    expirationDate: convertDate(data.expirationDate),
    location: data.location ? new City(data.location) : undefined,
  };
}
